var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2056 23.8225C17.1766 27.3434 18.4665 32.6866 20.7102 35.9263C21.8302 37.5461 22.9641 39 24.5172 39C24.5464 39 24.5758 38.9994 24.6058 38.9982C25.3355 38.9691 25.8628 38.7445 26.3726 38.5274C26.945 38.2834 27.537 38.0312 28.4655 38.0312C29.3489 38.0312 29.9126 38.2753 30.4578 38.5112C30.995 38.7436 31.5485 38.9841 32.3662 38.9687C34.1156 38.9362 35.1897 37.3673 36.1373 35.9832C37.1262 34.5381 37.6223 33.135 37.7896 32.5988L37.7964 32.5775C37.8283 32.4822 37.7833 32.3782 37.6919 32.3362C37.6894 32.3351 37.6801 32.3312 37.6775 32.3301C37.3694 32.2041 34.6671 31.0053 34.6387 27.7378C34.6124 25.0832 36.666 23.6774 37.0778 23.4226L37.097 23.4107C37.1416 23.382 37.1727 23.3364 37.1833 23.2843C37.1938 23.2323 37.1828 23.1782 37.1529 23.1344C35.7354 21.06 33.5628 20.7474 32.6881 20.7098C32.5612 20.6971 32.4302 20.6907 32.2986 20.6907C31.2712 20.6907 30.2871 21.0787 29.4964 21.3905C28.9506 21.6057 28.4792 21.7916 28.1541 21.7916C27.7887 21.7916 27.3146 21.6034 26.7656 21.3856C26.0314 21.0942 25.1993 20.7641 24.3184 20.7641C24.2974 20.7641 24.2767 20.7643 24.2563 20.7647C22.2081 20.7948 20.2726 21.9667 19.2056 23.8225Z",
    fill: "#0D0F27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6899 15.0002C31.4495 15.0507 29.9616 15.8142 29.0723 16.8559C28.3165 17.7314 27.5781 19.1913 27.7727 20.6627C27.7849 20.7548 27.8598 20.8259 27.9524 20.833C28.0361 20.8395 28.1216 20.8429 28.2067 20.8429C29.4195 20.8429 30.7279 20.172 31.6214 19.0916C32.5618 17.9507 33.0373 16.4867 32.8935 15.1752C32.8821 15.0725 32.7917 14.9961 32.6899 15.0002Z",
    fill: "#0D0F27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.5e1856c75aaabe819c2f82e8171761b8.svg";
export { ForwardRef as ReactComponent };